// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("jquery")
require("@nathanvda/cocoon")

//チャート追加
import Chart from "./Chart.bundle"
window.Chart = Chart; // Chartをグローバルスコープにエクスポート

import "./chartkick"

import $ from 'jquery';
window.$ = $;
window.jQuery = $;



import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "./slick"
import "./sliderSetting"


Rails.start()
Turbolinks.start()
ActiveStorage.start()
